// 财务报表模板
export default {
  state: {
    columnIndex: 1, // col y1
    rowIndex: 2, // row id:1
    tableHeaderList: [
      {
        prop: "y0",
        label: "示例列",
        guid: 1,
      }
    ],
    tableDataList: [
      {
        id: 1,
        guid: 1,
        y0: {
          label: '示例行'
        }
      }
    ],
  },
  mutations: {
    setColumnIndex(state, payload) {
      state.columnIndex = payload.columnIndex;
    },
    setRowIndex(state, payload){
      state.rowIndex = payload.rowIndex;
    },
    // 获取详情时赋值table数据
    setTableData(state, payload) {
      state.tableHeaderList = payload.tableHeaderList;
      state.tableDataList = payload.tableDataList;
    },
    // 表头像下添加
    setHeaderInsertBottom(state, payload) {
      const list = [...state.tableHeaderList];
      while (list.length) {
        const tmp = list.shift();
        if (tmp.guid === payload.col.guid) {
          if(!tmp.children) {
            tmp.children = [];
          }
          let obj = Object.assign({}, payload.col);
          tmp.children.splice(payload.index, 0, obj);
          return;
        }
        list.push(...(tmp.children || []));
      }
    },
    // 表头向右添加
    setHeaderInsertRight(state, payload) {
      const list = [...state.tableHeaderList];
  
      while (list.length) {
        const tmp = list.shift();
        if (tmp.guid === payload.col.parent_guid) {
          tmp.children.splice(payload.index, 0, payload.col);
          return;
        }
        list.push(...(tmp.children || []));
      }
    },
  },
  actions: {
    
  }
}